<script>
export default {
    name: 'Benefits',

    props: ['countValid', 'countExpired'],

    data() {
        return {
            selected: 'all',
        };
    },
    methods: {
        show(selected) {
            return this.selected === 'all' || this.selected === selected;
        },

        hasItems() {
            if (this.selected === 'active') {
                return this.countValid > 0;
            }

            if (this.selected === 'inactive') {
                return this.countExpired > 0;
            }

            return true;
        },
    },
};
</script>
